export const services = [
  {
    id: 'wof',
    title: 'WOF Inspections',
    shortDesc: 'MTA Assured inspections by qualified technicians. Honest assessments, no surprises.',
    fullDesc: 'Our MTA Assured Warrant of Fitness inspections are thorough, honest and carried out by fully qualified technicians. We check all safety critical items including lights, brakes, tyres, steering, suspension and windscreen to ensure your vehicle meets the required standard. If there are any failures, we will explain them clearly and give you a fair quote before any work begins. No unnecessary upselling, just straight talking service.',
    image: 'PHOTO: Mechanic performing WOF inspection checklist on a vehicle',
    icon: (
      <svg width="40" height="40" fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth="1.8">
        <path strokeLinecap="round" strokeLinejoin="round" d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
      </svg>
    ),
  },
  {
    id: 'engine',
    title: 'Engine Servicing',
    shortDesc: 'Full servicing including oils, filters, spark plugs and manufacturer scheduled maintenance.',
    fullDesc: 'Regular engine servicing is the best way to keep your vehicle reliable and avoid costly breakdowns. We carry out full engine servicing to manufacturer specifications, including oil and filter changes, air filters, spark plugs, fuel filters, timing belts and all scheduled maintenance items. Whether you drive a Japanese import, European or American vehicle, we have the knowledge and parts to service it correctly.',
    image: 'PHOTO: Mechanic performing engine service, changing oil or filters',
    icon: (
      <svg width="40" height="40" fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth="1.8">
        <path strokeLinecap="round" strokeLinejoin="round" d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" />
        <path strokeLinecap="round" strokeLinejoin="round" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
      </svg>
    ),
  },
  {
    id: 'tyres',
    title: 'Tyre Replacement and Repairs',
    shortDesc: 'Full range of tyres supplied and fitted. Puncture repairs carried out while you wait.',
    fullDesc: 'We stock a comprehensive range of tyres to suit all vehicles and budgets, from budget-friendly options through to premium performance brands. Our team will help you choose the right tyre for your vehicle and driving style. Puncture repairs are carried out quickly while you wait. We also offer tyre rotation and pressure checks to help extend the life of your tyres.',
    image: 'PHOTO: Technician fitting a new tyre onto a vehicle wheel',
    icon: (
      <svg width="40" height="40" fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth="1.8">
        <circle cx="12" cy="12" r="9" />
        <circle cx="12" cy="12" r="3" />
        <path strokeLinecap="round" d="M12 3v3M12 18v3M3 12h3M18 12h3" />
      </svg>
    ),
  },
  {
    id: 'alignment',
    title: '3D Laser Wheel Alignment',
    shortDesc: 'Precision 3D laser alignment for improved handling, tyre wear and fuel efficiency.',
    fullDesc: 'Our state of the art 3D laser wheel alignment system delivers precision results you can feel the moment you drive away. Misaligned wheels cause uneven tyre wear, poor handling and increased fuel consumption. We measure all four wheels simultaneously, compare against manufacturer specifications and make precise adjustments. A full alignment report is provided so you can see exactly what was corrected.',
    image: 'PHOTO: 3D laser wheel alignment equipment set up on a vehicle in the workshop',
    icon: (
      <svg width="40" height="40" fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth="1.8">
        <circle cx="12" cy="12" r="3" />
        <circle cx="12" cy="12" r="8" />
        <path strokeLinecap="round" d="M12 2v2M12 20v2M2 12h2M20 12h2" />
      </svg>
    ),
  },
  {
    id: 'brakes',
    title: 'Brake, Steering and Suspension',
    shortDesc: 'Safety critical repairs carried out correctly, road tested before every handover.',
    fullDesc: 'Your brakes, steering and suspension are critical to the safety of your vehicle. We carry out comprehensive repairs across all of these systems, including brake pad and disc replacement, wheel bearing replacements, shock absorber and strut replacements, tie rod ends, ball joints, rack and pinion repairs and cooling system work. Every vehicle is road tested before being returned to you.',
    image: 'PHOTO: Mechanic inspecting brake disc and caliper on a lifted vehicle',
    icon: (
      <svg width="40" height="40" fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth="1.8">
        <circle cx="12" cy="12" r="9" />
        <circle cx="12" cy="12" r="5" />
        <path strokeLinecap="round" d="M12 7v5l3 3" />
      </svg>
    ),
  },
  {
    id: 'ecu',
    title: 'ECU Chiptuning',
    shortDesc: 'Professional ECU tuning for increased power output and improved fuel efficiency.',
    fullDesc: 'Our professional ECU chiptuning service unlocks the hidden potential in your engine without the need for expensive hardware modifications. By remapping the engine control unit, we can increase power output, improve throttle response and optimise fuel delivery for better efficiency. ECU tuning is available for a wide range of petrol and diesel vehicles. All tuning is carried out by experienced technicians using professional grade equipment.',
    image: 'PHOTO: Technician connecting diagnostic laptop to vehicle OBD port for ECU tuning',
    icon: (
      <svg width="40" height="40" fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth="1.8">
        <path strokeLinecap="round" strokeLinejoin="round" d="M13 10V3L4 14h7v7l9-11h-7z" />
      </svg>
    ),
  },
  {
    id: 'transmission',
    title: 'Transmission Servicing',
    shortDesc: 'Gearbox and driveline fluid and filter replacements to protect your drivetrain.',
    fullDesc: 'Transmission and driveline servicing is often overlooked but is essential to the longevity of your gearbox, differential and drivetrain components. We carry out automatic and manual transmission fluid and filter replacements, differential oil changes and transfer case servicing. Using the correct fluids to manufacturer specifications, we help prevent premature wear and costly gearbox failures down the road.',
    image: 'PHOTO: Mechanic performing transmission fluid service on a vehicle',
    icon: (
      <svg width="40" height="40" fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth="1.8">
        <path strokeLinecap="round" strokeLinejoin="round" d="M8 9l3 3-3 3m5 0h3M5 20h14a2 2 0 002-2V6a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
      </svg>
    ),
  },
  {
    id: 'diagnostic',
    title: 'Full Diagnostic Health Reports',
    shortDesc: 'Latest scan tools to accurately identify issues before any repair work begins.',
    fullDesc: 'Guesswork costs money. Our full diagnostic health reports use the latest OBD scan tools and diagnostic software to accurately read fault codes, live sensor data and system status across your entire vehicle. We provide a clear, easy to understand report covering all major systems. This allows us to identify issues accurately, explain them to you clearly and provide an honest, accurate quote before any work is authorised.',
    image: 'PHOTO: Diagnostic scan tool displaying live vehicle data on screen in workshop',
    icon: (
      <svg width="40" height="40" fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth="1.8">
        <path strokeLinecap="round" strokeLinejoin="round" d="M9 17v-2m3 2v-4m3 4v-6m2 10H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
      </svg>
    ),
  },
  {
    id: 'battery',
    title: 'Battery Replacement',
    shortDesc: 'Battery replacements plus free charging system inspections on every visit.',
    fullDesc: 'A flat or failing battery leaves you stranded. We carry a full range of replacement batteries to suit cars, utes, SUVs and vans. On every visit we offer a free battery and charging system inspection, testing your battery health, alternator output and starter motor current draw. If your battery is getting low, we will let you know before it lets you down. Battery replacements are fast and we can often have you back on the road within the hour.',
    image: 'PHOTO: Mechanic testing car battery with diagnostic tester',
    icon: (
      <svg width="40" height="40" fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth="1.8">
        <rect x="2" y="7" width="18" height="11" rx="2" />
        <path strokeLinecap="round" strokeLinejoin="round" d="M20 10h2v5h-2M7 11v3M10 11v3M13 11v3" />
      </svg>
    ),
  },
];
